var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:{
  'status-span-center': _vm.isOff
}},[_c('span',{staticClass:"status-span"},[_vm._v("\n    "+_vm._s(_vm.bonusType)+"\n  ")]),(!_vm.isOff)?_c('span',{staticClass:"status-span",class:{
      'green': !_vm.isDiscount,
      'danger':_vm.isDiscount
    }},[_vm._v("\n    "+_vm._s(_vm.bonusPercentage)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }